import { notNull } from '@gap/utils/utils'
import Fuse from 'fuse.js'

export function replaceItemInArray<T>(array: T[], oldItem: T, newItem: T) {
   const index = removeItemFromArray(array, oldItem)
   insertItemIntoArray(array, newItem, index)
}

export function removeItemFromArray<T>(array: T[], item: T) {
   const index = array.indexOf(item)
   if (index >= 0) {
      array.splice(index, 1)
   }
   return index
}
export function removeIndexFromArray<T>(array: T[], index: number) {
   if (index >= 0) {
      array.splice(index, 1)
   }
}

export function removeFromArray<T>(array: T[], predicate: (item: T) => boolean) {
   const index = array.findIndex(predicate)
   if (index >= 0) {
      array.splice(index, 1)
      return true
   }
   return false
}


export function insertItemIntoArray<T>(array: T[], item: T, index?: number) {
   if (index !== undefined) {
      array.splice(index, 0, item)
      return array[index]
   } else {
      array.push(item)
      return notNull(lastArrayItem(array))
   }
}

export function isArray(v: any): v is Array<any> {
   // works for both simple arrays and mobx observables as well
   return !!v && !!v.map && !!v.slice && !!v.splice
}

export function removeAllItemsFromArray<T>(array: T[]): void {
   array.splice(0, array.length)
}

export function firstArrayItem<T>(array: T[]): T | undefined {
   return array[0]
}

export function lastArrayItem<T>(array: T[]): T | undefined {
   return array[array.length - 1]
}

/**
 * This function will quickly turn an array into an object where the array keys are the objects keys
 * @param array array of strings
 * @returns Object version, where every key is set to true
 * @example
 * const allowed = ['inputProps', 'fieldProps']
 * const allowedObj = arrayToSimpleObject(allowed)
 * if (allowedObj.inputprops) {
 *    // Do stuff
 * }
 */
export function arrayToSimpleObject<T extends string>(array: string[]): Record<T, boolean> {
   const objKeys: any = {};
   for (const item of array)
      objKeys[item] = true;
   return objKeys;
}

/**
 * Try to find the closest match in an array
 * @param input Your search string
 * @param items Your array of items 
 * @param field The attribute field you are searching for
 * @returns keyof items
 * @example
 * const myClients = [{ id: 555, name: 'Albert' }, { id: 666, name: 'Johnie' }, { id: 777, name: 'Primo Stuff' }]
 * const bestMatch = findClosestMatch('john', myClients, 'name')
 * // bestMatch = { id: 666, name: 'Johnie' }
 */
export function findClosestMatch<T>(
   input: string,
   items: T[],
   field: keyof T
): T | null {
   if (!items.length) return null;

   const fuse = new Fuse(items, {
      keys: [field as string],
      threshold: 0.4,
   });

   const result = fuse.search(input);
   return result.length > 0 ? result[0].item : null;
}
